import assign = require('object-assign');
import { 
    FETCH_REQUEST, 
    FETCH_SUCCESS, 
    FETCH_FAILURE 
} from '../constants/ReportTemplate';

import { IReportTemplatesState } from '../interfaces/states';

const initialState: IReportTemplatesState = {
    byId: {},
    arr: []
};

export default function states(state = initialState, action): IReportTemplatesState {
    switch (action.type) {
        case FETCH_REQUEST: {
            return assign({}, state, {
                loading: true
            });
        }
        case FETCH_SUCCESS: {
            const byId = {};
            const arr = [];

            const templates = action.payload;

            templates.forEach(template => {
                const id = template.rtId || template.defaultTemplateId;

                byId[id] = template;
                arr.push(id);
            });

            return assign({}, state, {
                loading: false,
                byId,
                arr
            });
        }
        case FETCH_FAILURE: {
            return assign({}, state, {
                loading: false,
                error: action.error
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/reportTemplates.ts